"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const carabiners_1 = require("@clearsummit/carabiners");
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const RadioGroup = ({ className, onChange, options, readonly, value, }) => (react_1.default.createElement("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.container, className) }, options.map((opt) => (react_1.default.createElement(__1.SubscriptionRadio, { key: `radio-item-${opt.value}`, labelString: opt.label, onChange: () => onChange(opt.value), value: value === opt.value, description: opt.description, readonly: readonly, id: opt.value })))));
exports.RadioGroup = RadioGroup;
exports.RadioGroup.defaultProps = {
    className: undefined,
    options: [],
    readonly: false
};
exports.default = exports.RadioGroup;
